export const getReviewsData = () => [
  {
    id: "6a29b15ee0d984bc5abdd937",
    product: {
      title: "Spiral Marquise Row Ring",
      url: "/products/JWL0205/sterling-silver-spiral-marquise-row-ring",
    },
    sender: "Philip G.",
    text: "Ordering was made easy, with multiple designs to pick from and great craftsmanship. She loved it!",
    title: "Ordering was made easy",
  },
  {
    id: "6a2819a6b3216bf7cacc6b54",
    product: {
      title: "Beautiful Blossoms with Split Shank Ring",
      url: "/products/JWL0454/sterling-silver-beautiful-blossoms-with-split-shank-ring-and-white-premium-zirconia-stone",
    },
    sender: "Annette H.",
    text: "Beautiful ring just as pictured. Very quick delivery and great communication.",
    title: "Beautiful ring just as pictured",
  },
  {
    id: "6a17f613de5a36647ec12031",
    product: {
      title: "Men's Cache Square-shaped Gemstone Ring",
      url: "/products/JWLM0016/men's-cache-square-shaped-gemstone-ring",
    },
    sender: "Rob T.",
    text: "Designing and ordering our rings was easy, fabrication and shipping were fast. We love our rings.",
    title: "Great experience all around!",
  },
  {
    id: "6a315cefe8e260a4e6d8c322",
    product: {
      title: "Engravable Two Name Infinity Necklace",
      url: "/products/JWLN0736/sterling-silver-engravable-two-name-infinity-necklace",
    },
    sender: "Conrad B.",
    text: "The website is excellent, showing the personalized product exactly as it is. This takes all the guesswork out of ordering online.",
    title: "The website is excellent",
  },
]
